import { render, staticRenderFns } from "./ScopeRibbonFeedback.vue?vue&type=template&id=82f5bb9e&"
import script from "./ScopeRibbonFeedback.vue?vue&type=script&lang=js&"
export * from "./ScopeRibbonFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports